//React
import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Add
import { imageResize, imageRotate } from '../func/imageResizeRotate';
import { withAlert } from 'react-alert';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as myPhotoAction from '../action/myPhotoAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import Fab from '@material-ui/core/Fab';

//Icon
import CloseIcon from '@material-ui/icons/Close';
import ClearIcon from '@material-ui/icons/Clear';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CropIcon from '@material-ui/icons/Crop';
//Part
import PartDropZone from './PartDropZone';
import PartImageUploadHelp from './PartImageUploadHelp';
//Dialog
import DialogImageCrop from './DialogImageCrop';
//Part
import PartInputInfoBalloon from './PartInputInfoBalloon'

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      originImage: null,
      uploadThumb: null,
      uploadSecret: false,
      uploadSubmitVisible: false,
      uploadProgress: null,
      dialogImageCropVisible: false,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.originImage !== this.state.originImage && this.state.originImage) {
      this._imageLoad(this.state.originImage);
    }
  }

  async _imageLoad(file) {
    await imageResize(file, 1200).then((res) => {
      this.setState({uploadThumb:res.uri});
    }).catch((err) => {
      this.setState({uploadThumb:null});
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  async _imageRotate(rotate) {
    let file = this.state.uploadThumb;
    await imageRotate(file, rotate).then((res) => {
      this.setState({uploadThumb:res.uri});
    })
  }

  _submit() {
    let imageBase64 = this.state.uploadThumb;
    let secret = (this.state.uploadSecret) ? 1: 0;
    this.props.myPhotoAdd(imageBase64, secret, () => {
      this.setState({originImage:null, uploadThumb:null});
      this.props.close();
    })
  }


	render() {
		return (
			<Dialog
        open={this.props.open}
        maxWidth='xs'
      >
        <div
          style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'space-between',
          }}
        >
          <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
            サブ写真の登録
          </div>
          <IconButton
            onClick={ () => {
              this.props.close();
              this.setState({uploadThumb: null});
            }}
          >
            <CloseIcon/>
          </IconButton>
        </div>

        <div>

          <div style={{padding:'10px'}}>
            <div style={{color:'#666'}} align='center'>
              サブ写真はお顔が映っていない<br />風景などのお写真も掲載できます
            </div>

            <div style={{padding:'5px'}}>
              <div align='center'>
                <label style={{cursor:"pointer"}}>
                  <Checkbox
                    checked={this.state.uploadSecret}
                    onChange={ () => this.setState({uploadSecret: (this.state.uploadSecret ? false : true)}) }
                    color="primary"
                  />
                  <u>
                    シークレット写真で掲載する
                  </u>
                </label>
              </div>


              {
                (this.state.uploadSecret) && (
                  <div align='center' >
                    <PartInputInfoBalloon>
                      <div>あなたがお気に入りに登録した方<br />だけに公開する設定です</div>
                    </PartInputInfoBalloon>
                  </div>
                )
              }

            </div>


            {
              (this.state.uploadThumb) ?
              <div>
                <div style={{textAlign:'center', margin:'5px', position:'relative', minHeight:'50px'}}>
                  <div align='center' style={{padding:'5px', position:'relative'}}>
                      <img style={{ width:'160px', height:'160px', objectFit:'contain' }} src={this.state.uploadThumb} id='thumb' alt=''/>
                  </div>
                  <IconButton
                    style={{position:'absolute', right:'0px', top:'0px'}}
                    onClick={ () => this.setState({originImage:null, uploadThumb:null}) }
                  >
                    <ClearIcon/>
                  </IconButton>
                </div>


                <div align='center'>
                  <Fab
                    color='inherit'
                    size='small'
                    onClick={ () => this._imageRotate('l')}
                  >
                    <RotateLeftIcon/>
                  </Fab>
                  &nbsp;
                  <Fab
                    color='inherit'
                    size='small'
                    onClick={ () => this._imageRotate('r')}
                  >
                    <RotateRightIcon/>
                  </Fab>
                  &nbsp;
                  <Fab
                    color='inherit'
                    size='small'
                    onClick={ () => this.setState({dialogImageCropVisible: true}) }
                  >
                    <CropIcon/>
                  </Fab>
                </div>

                <DialogImageCrop
                  originImage={this.state.originImage}
                  open={this.state.dialogImageCropVisible}
                  close={ () => this.setState({dialogImageCropVisible: false}) }
                  onSubmit={ (img) => this.setState({uploadThumb:img}) }
                />



                <div align='center' style={{padding:'10px'}}>

                  <Button
                    variant="contained"
                    color="secondary"
                    style={{minWidth:'160px'}}
                    onClick={ () => this._submit() }
                    startIcon={<CloudUploadIcon />}
                  >
                    <span style={{fontSize:'1.4em'}}>アップロード</span>
                  </Button>
                </div>
              </div>
              :
              <PartDropZone
                handleDrop={ (v) => this.setState({originImage:v}) }
                style={{position:'relative'}}
              >
                <div>
                  <div align='center' style={{padding:'10px'}}>
                    <label htmlFor="photo_file" style={{display:'block'}}>
                      <IconButton component="span">
                        <AddAPhotoIcon style={{fontSize:'4em'}}/>
                      </IconButton>
                    </label>

                    <label htmlFor="photo_file" style={{cursor:"pointer", display:'block'}}>
                      <Button variant="contained" color='primary' component="span">
                        <div>
                          <span style={{fontSize:'1.2em'}}>ファイルを選択する</span>

                        </div>
                      </Button>
                    </label>
                  </div>
                </div>

              </PartDropZone>
            }
            <input
              type='file'
              id='photo_file'
              accept='image/*'
              onChange={ (e) => {
                this.setState({originImage: e.target.files[0]});
                e.target.value = null;
              }}
              style={{opacity:'0'}}
            />

            <div style={{padding:'5px'}} align='right'>
              <PartImageUploadHelp />
            </div>
          </div>

        </div>
			</Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...myPhotoAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withAlert()(Comp));
